import React from 'react';
export function ContentSection() {
  return <section className="py-6 px-4 bg-white" data-id="element-66">
      <div className="max-w-4xl mx-auto" data-id="element-67">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-6" data-id="element-68">
          📚 ESTO ES TODO LO QUE INCLUYE
        </h2>

        <div className="bg-white p-5 rounded-lg shadow-lg mb-4" data-id="element-69">
          <h3 className="text-2xl md:text-3xl font-black mb-4" data-id="element-70">
            📘 6 TOMOS COMPLETOS
          </h3>
          <ul className="space-y-2" data-id="element-71">
            <li className="flex items-start" data-id="element-72">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-73">✔</span>
              <span className="text-xl" data-id="element-74">Introducción al dinero</span>
            </li>
            <li className="flex items-start" data-id="element-75">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-76">✔</span>
              <span className="text-xl" data-id="element-77">Cómo administrar el dinero</span>
            </li>
            <li className="flex items-start" data-id="element-78">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-79">✔</span>
              <span className="text-xl" data-id="element-80">Hábitos que crean riqueza</span>
            </li>
            <li className="flex items-start" data-id="element-81">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-82">✔</span>
              <span className="text-xl" data-id="element-83">Pensar como rico</span>
            </li>
            <li className="flex items-start" data-id="element-84">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-85">✔</span>
              <span className="text-xl" data-id="element-86">Sistema financiero familiar</span>
            </li>
            <li className="flex items-start" data-id="element-87">
              <span className="text-green-600 font-bold text-2xl mr-3" data-id="element-88">✔</span>
              <span className="text-xl" data-id="element-89">Dinero, valores y legado</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}
export default ContentSection;